import React from 'react';
import PropTypes from 'prop-types';

import HorseDefinition from '../../../shared/HorseDefinition';

const DamSire = ({
    damSireHorseName,
    damSireUid,
    damSireCountryOriginCode,
    damSireAvgFlatWinDist,
    isWeatherbysMobile,
}) => (
    <HorseDefinition
        avgFlatWinDist={damSireAvgFlatWinDist}
        countryOriginCode={damSireCountryOriginCode}
        horseName={damSireHorseName}
        horseUid={damSireUid}
        term={isWeatherbysMobile ? '' : 'Dam\'s Sire'}
    />
);

DamSire.propTypes = {
    damSireHorseName: PropTypes.string,
    damSireUid: PropTypes.number,
    damSireCountryOriginCode: PropTypes.string,
    damSireAvgFlatWinDist: PropTypes.number,
    isWeatherbysMobile: PropTypes.bool,
};

export default DamSire;



// WEBPACK FOOTER //
// ./src/js/horse/details/components/DamSire.jsx